export default __webpack_public_path__ + "static/media/consumption-phone.54a5cfdb.png";